/**
 * @desc 修改网站公告
 */
import { NoticeEntity, NoticeForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateNoticeParameter = NoticeForm

const method = 'PUT'
const url = '/content/operation/notice'

export const updateNoticeApi = (
  data?: UpdateNoticeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<NoticeEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateNoticeApi.method = method
updateNoticeApi.url = url
